import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CountersService } from '../services/counters.service';
import { NavigationService } from '../services/navigation.service';
import { Counter, TaskListConfiguration } from '../shared/models';

@Component({
  selector: 'app-channels-navigation',
  templateUrl: './channels-navigation.component.html',
  styleUrls: ['./channels-navigation.component.scss'],
})
export class ChannelsNavigationComponent implements OnInit, OnDestroy {
  @Input() taskListConfiguration: TaskListConfiguration;

  stateInboxNg = 'auth.alcmeon.inbox.list.tasks';
  channelsTaskListConfigs: TaskListConfiguration[];
  counters: Counter[] = [];

  private subscriptions = new Subscription();

  constructor(
    private countersService: CountersService,
    private navigationService: NavigationService,
    @Inject('$state') private $state: any
  ) {
    // these 2 subscribe needs to be in constructor, to be subscribed before the init of all three components : this one, TabsNavigationComponent, InsertsByMeComponent

    this.subscriptions.add(
      this.countersService.initCounterIndexesBS.subscribe(() => {
        this.updateCounterIndexes();
      })
    );

    this.subscriptions.add(
      this.countersService.countersBS.subscribe(counters => {
        this.updateCountersForDisplay(counters);
      })
    );
  }

  ngOnInit(): void {
    this.channelsTaskListConfigs = this.navigationService.getAllChannelsTaskListConfigs(this.taskListConfiguration);
    this.countersService.initChannelsCounters(this.channelsTaskListConfigs, this.taskListConfiguration);

    this.subscriptions.add(
      this.navigationService.loadChannelQueueBS.subscribe(queueId => {
        this.$state.go(
          this.stateInboxNg,
          {
            queueId: this.taskListConfiguration.queueId,
            channelQueueId: queueId,
          },
          {
            reload: this.stateInboxNg,
          }
        );
      })
    );
  }

  selectChannel(channel: TaskListConfiguration) {
    this.loadQueue(channel.queueId);
  }

  /**
   * Allows to load the given queue through the mecanism that wait 300ms between clicks to avoid HTTP errors 429 with the `crazies click monkeys`.
   * @param channelQueueId
   */
  private loadQueue(channelQueueId: string) {
    this.navigationService.loadChannelQueueBS.next(channelQueueId);
  }

  /**
   * Inject counter indexes in channelsTaskListConfigs.
   * The goal is to know if a counter will be displayed or not, before countersBS is notified.
   * So we display a loading counter or nothing.
   */
  private updateCounterIndexes() {
    let counterIndex = 0;
    this.channelsTaskListConfigs.forEach(config => {
      config.counterIndex = this.countersService.channelsCounterIndexes[counterIndex];
      counterIndex++;
    });
  }

  /**
   * Inject counters in channelsTaskListConfigs
   */
  private updateCountersForDisplay(counters: Counter[]) {
    if (counters?.length) {
      this.counters = counters;
      this.channelsTaskListConfigs.forEach(config => {
        if (config.counterIndex >= 0 && this.counters[config.counterIndex]) {
          config.counter = [this.counters[config.counterIndex].counter];
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
